/**
 * Mapeia o estado da Calculadora Solar ou uma proposta salva
 * para o payload único de geração de PDF/PPTX.
 *
 * Alterações de campos da proposta devem ser feitas aqui — as duas telas
 * (Calculadora Solar e Consulta de Propostas) passam a usar o mesmo documento.
 */

import { estimarKwhPorKwp, formatCpfProposta, slugNomeArquivo } from './constantes'

/**
 * @typedef {object} DadosDocumentoProposta
 * @property {string} nomeCliente
 * @property {string|null} cpf
 * @property {string|Date} dataProposta
 * @property {string|Date} dataValidade
 * @property {number|string|null} kwh
 * @property {number} projetoKwp
 * @property {string|null} moduloNome
 * @property {number} moduloPotencia
 * @property {number} quantidadePaineis
 * @property {number} inversor
 * @property {'padrao'|'personalizada'|null} tipoProposta
 * @property {object|null} kitValorSelecionado
 * @property {number} valorKit
 * @property {number} totalComPorcentagem  — investimento sem majoração (economia/payback)
 * @property {number} totalProposta        — investimento com majoração
 * @property {string} [fileNameBase]
 */

export function montarDadosDocumentoCalculadora({
  formData,
  resultados,
  kwhParaProposta,
  moduloParaProposta
}) {
  const majoracao = parseFloat(formData.majoracao) || 0
  const totalComPorcentagem = resultados.totalComPorcentagem || 0
  const nome = (formData.nomeCliente || '').trim()
  const hoje = new Date()

  return {
    nomeCliente: nome,
    cpf: formData.cpf || null,
    dataProposta: hoje,
    dataValidade: new Date(Date.now() + 3 * 24 * 60 * 60 * 1000),
    kwh: kwhParaProposta,
    projetoKwp: resultados.projetoKwp || 0,
    moduloNome: moduloParaProposta?.modulo || null,
    moduloPotencia: moduloParaProposta?.potencia_wp || 0,
    quantidadePaineis: resultados.quantidadePaineis || 0,
    inversor: resultados.inversor || 0,
    tipoProposta: formData.tipoProposta || 'padrao',
    kitValorSelecionado: formData.kitValorSelecionado || null,
    valorKit: resultados.valorKit || 0,
    totalComPorcentagem,
    totalProposta: totalComPorcentagem + majoracao,
    fileNameBase: `Proposta_Solar_${slugNomeArquivo(nome)}_${hoje.toISOString().split('T')[0]}`
  }
}

export function montarDadosDocumentoPropostaSalva(proposta) {
  const kwp = Number(proposta.kwp_proposta) || 0
  const potencia = Number(proposta.modulo_potencia) || 0
  const majorado = Number(proposta.majorado) || 0
  const totalProposta = Number(proposta.total_proposta) || 0
  const nome = (proposta.nome_cliente || '').trim()

  return {
    nomeCliente: nome,
    cpf: formatCpfProposta(proposta.cpf),
    dataProposta: proposta.data_proposta,
    dataValidade: proposta.data_validade,
    kwh: estimarKwhPorKwp(kwp),
    projetoKwp: kwp,
    moduloNome: potencia ? `Módulo ${potencia}W` : null,
    moduloPotencia: potencia,
    quantidadePaineis: Number(proposta.quantidade_placas) || 0,
    inversor: Number(proposta.potencia_inversor) || 0,
    tipoProposta: null,
    kitValorSelecionado: null,
    valorKit: Number(proposta.valor_kit) || 0,
    totalComPorcentagem: totalProposta - majorado,
    totalProposta,
    fileNameBase: `Proposta_${slugNomeArquivo(nome)}_${proposta.id}`
  }
}
